'use client';

import { CheckboxActiveIcon } from '@/components/icons/svg-icons';
import { useTranslations } from 'next-intl';
import { useEffect, useRef, useState } from 'react';

export const ToastTop = () => {
	const [message, setMessage] = useState('');
	const t = useTranslations('General');
	const toastTimerRef = useRef<ReturnType<typeof setTimeout>>();

	const clearToastMessage = () => {
		setMessage('');
	}

	useEffect(() => {
		const setToastMsg = ((event: CustomEvent) => {
			const msg = event.detail.resourceKey ? t(event.detail.resourceKey) : event.detail.msg;
			if (msg) {
				if (toastTimerRef.current) {
					clearTimeout(toastTimerRef.current);
				}

				setMessage(msg);

				toastTimerRef.current = setTimeout(() => {
					clearToastMessage();
				}, 3000);
			} else {
				clearToastMessage();
			}
		}) as EventListener;

		document.addEventListener('show-toast-top-msg', setToastMsg);

		return () => {
			document.removeEventListener('show-toast-top-msg', setToastMsg);
			clearTimeout(toastTimerRef.current);
		};
	}, [t]);

	return message ? (
		<div className="toast toast--top toast--success">
			<div className="toast__icon">
				<CheckboxActiveIcon />
			</div>
			<div className="toast__text">{message}</div>
		</div>
	) : null;
}